import * as types from '../const/action.types';
import { put } from '../api/_basic';

export function reportsLotIsLoading(bool) {
    return {
        type: types.REPORT_LOT_IS_LOADING,
        isLoading: bool,
    };
}

export function reportsLotFieldsFetchDataSuccess(items) {
    return {
        type: types.REPORT_LOT_FETCH_DATA,
        items,
    };
}

export function loadLotTempValues(from, to, local, type, value) {
    return async (dispatch) => {
        dispatch(
            reportsLotFieldsFetchDataSuccess({
                from: from,
                to: to,
                local: local,
                type: type,
                value: value,
            }),
        );
        dispatch(reportsLotIsLoading(true));
        try {
            const body = {};
            if (from) body.fechaI = from;
            if (to) body.fechaF = to;
            if (local) body.local = local;
            if (value) body[type] = value;

            const response = await put(
                type === 'lote'
                    ? process.env.REACT_APP_API_REPORT_SEARCH_LOTE
                    : process.env.REACT_APP_API_REPORT_SEARCH_TEMP,
                body,
            );

            dispatch(reportsLotIsLoading(false));
            if (response.error !== undefined) {
                throw Error(response);
            }
            const field = {
                from: from,
                to: to,
                local: local,
                type: type,
                value: value,
                values: response,
            };
            dispatch(reportsLotFieldsFetchDataSuccess(field));
        } catch (error) {
            dispatch(reportsLotIsLoading(false));
            throw error;
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.reports.lot.actions.js